"use strict";

define('uikit/elements/button',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','../extra/size','../extra/color','../templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var Templates = require('../templates');
  var ButtonView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui button',
    allowTagChange: true,
    template: Templates.UIKit['button'],
    triggers: {
      'mousedown': {
        event: 'before:press',
        preventDefault: false,
        stopPropagation: false
      }
    },
    events: {
      'keydown': function keydown(ev) {
        if (ev.keyCode == 13 && !this.disabled) {
          this.triggerMethod('before:press');
          this.triggerMethod('press');
        }
      },
      'click': function click(ev) {
        if (this.stopPropagation) {
          ev.stopPropagation();
        }
        this.triggerMethod('press', {
          view: this,
          model: this,
          collection: this.collection
        });
      }
    },
    options: {
      role: 'button',
      ariaLabel: null,
      visible: true,
      text: '',
      disabled: false,
      icon: '',
      iconRight: false,
      loading: false,
      color: '',
      size: '',
      basic: false,
      basicText: false,
      inline: false,
      circular: false,
      inverted: false,
      fluid: false,
      labeled: false,
      link: '',
      active: false,
      floated: '',
      compact: false,
      stopPropagation: false
    },
    colorOptionValues: _.values(Color),
    sizeOptionValues: _.values(Size),
    update: {
      ariaLabel: true,
      disabled: false,
      active: false,
      iconRight: true,
      loading: false,
      color: false,
      size: false,
      basic: false,
      basicText: false,
      inline: false,
      circular: false,
      inverted: false,
      visible: false,
      floated: false,
      fluid: false,
      labeled: false,
      link: false,
      compact: false,
      stopPropagation: false
    },
    updateAttributes: function updateAttributes() {
      var attrs = {
        role: this.getOption('role')
      };
      if (this.getOption('ariaLabel')) {
        attrs['aria-label'] = this.getOption('ariaLabel');
      }
      if (this.getBoolOption('disabled')) {
        attrs['aria-disabled'] = this.getOption('disabled');
      } else {
        this.removeElementAttribute('aria-disabled');
      }
      this.updateElementAttributes(attrs);
      if (this.visible) {
        this.$el.attr('tabindex', 0);
      } else {
        this.$el.attr('tabindex', -1);
      }
      this.addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated')).addClass("disabled", this.getBoolOption("disabled")).addClass("icon", this.getBoolOption("icon") && !this.getBoolOption('text') || this.getBoolOption('labeled') && this.getBoolOption('icon')).addClass("right", this.getBoolOption("iconRight")).addClass("labeled", this.getBoolOption("icon") && this.getBoolOption("text") && this.getBoolOption('labeled')).addClass("loading", this.getBoolOption("loading")).addClass("basic", this.getBoolOption("basic") && !this.getBoolOption('basicText')).addClass('inline', this.getBoolOption('basicText') || this.getOption('inline')).addClass("circular", this.getBoolOption("circular")).addClass('inverted', this.getBoolOption('inverted')).addClass('fluid', this.getBoolOption('fluid')).addClass('active', this.getBoolOption('active')).addClass('compact', this.getBoolOption('compact')).addClass(this.getOption('color'), this.getBoolOption('color')).addClass(this.getOption('size'), this.getBoolOption('size'));
      if (this.getOption('link')) {
        if (_.isString(this.getOption('link'))) {
          this.$el.attr('href', this.getOption('link'));
        }
        if (this.getOption('target')) {
          this.$el.attr('target', this.getOption('target'));
        }
      } else {
        this.$el.removeAttr('href');
      }
    }
  }, {});
  ButtonView.MINI = 'mini';
  ButtonView.TINY = 'tiny';
  ButtonView.SMALL = 'small';
  ButtonView.MEDIUM = 'medium';
  ButtonView.LARGE = 'large';
  ButtonView.BIG = 'big';
  ButtonView.HUGE = 'huge';
  ButtonView.MASSIVE = 'massive';
  channel.reply('button', function () {
    return ButtonView;
  });
  module.exports = ButtonView;
});

